import { supabase } from '../lib/supabaseClient.js';
import { TABLES, UNIT_STATUS } from '../lib/constants.js';

const UNIT_WITH_TENANT = '*, tenant:profiles!units_current_tenant_id_fkey(id, full_name, email, phone)';

function randomGroup() {
  const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  const bytes = crypto.getRandomValues(new Uint8Array(4));
  return Array.from(bytes, value => alphabet[value % alphabet.length]).join('');
}

function genActivationCode() {
  const bytes = crypto.getRandomValues(new Uint8Array(2));
  const number = 1000 + ((bytes[0] * 256 + bytes[1]) % 9000);
  return `${randomGroup().slice(0, 2)}-${number}-${randomGroup().slice(0, 2)}`;
}

export async function listUnitsByProperty(propertyId) {
  const { data, error } = await supabase.from(TABLES.UNITS).select(UNIT_WITH_TENANT)
    .eq('property_id', propertyId).order('unit_number');
  if (error) throw error;
  return data;
}

export async function listAllUnits() {
  const { data, error } = await supabase.from(TABLES.UNITS).select(UNIT_WITH_TENANT);
  if (error) throw error;
  return data;
}

export async function addUnit({ propertyId, unitNumber, floor, currentTenantId = null }) {
  const { data, error } = await supabase.from(TABLES.UNITS).insert({
    property_id: propertyId,
    unit_number: unitNumber,
    floor: floor ?? null,
    current_tenant_id: currentTenantId,
    tenant_activation_code: genActivationCode(),
    status: currentTenantId ? UNIT_STATUS.OCCUPIED : UNIT_STATUS.VACANT
  }).select(UNIT_WITH_TENANT).single();
  if (error) throw error;
  return data;
}

export async function updateUnit(id, patch) {
  const { data, error } = await supabase.from(TABLES.UNITS).update(patch).eq('id', id).select(UNIT_WITH_TENANT).single();
  if (error) throw error;
  return data;
}

export async function regenerateActivationCode(id) {
  return updateUnit(id, { tenant_activation_code: genActivationCode() });
}

/** Archive the current tenant before vacating the unit. The actual start date is required. */
export async function unlinkUnit(id, currentUnit, startedAt) {
  if (currentUnit.current_tenant_id) {
    if (!startedAt) throw new Error('يلزم تحديد تاريخ بداية الإشغال قبل حفظ سجل المستأجر.');
    const { error: historyError } = await supabase.from(TABLES.UNIT_TENANT_HISTORY).insert({
      unit_id: id,
      tenant_id: currentUnit.current_tenant_id,
      started_at: startedAt,
      ended_at: new Date().toISOString()
    });
    if (historyError) throw historyError;
  }

  return updateUnit(id, {
    current_tenant_id: null,
    status: UNIT_STATUS.VACANT,
    tenant_activation_code: genActivationCode()
  });
}

export async function getUnitHistory(unitId) {
  const { data, error } = await supabase.from(TABLES.UNIT_TENANT_HISTORY)
    .select('*, tenant:profiles!unit_tenant_history_tenant_id_fkey(full_name, email, phone)')
    .eq('unit_id', unitId).order('ended_at', { ascending: false, nullsFirst: false });
  if (error) throw error;
  return data;
}

export function subscribeUnits(onChange) {
  return supabase.channel('units-changes')
    .on('postgres_changes', { event: '*', schema: 'public', table: TABLES.UNITS }, onChange)
    .subscribe();
}
